import { __spreadArray } from "tslib";
import React, { useEffect, useState } from 'react';
import { Div, Button } from '@pezeshk-book/ui-kit';
import classNames from '../../utils/class-names';
var Slider = function (_a) {
    var children = _a.children, _b = _a.delay, delay = _b === void 0 ? 2500 : _b, _c = _a.spaceBetween, spaceBetween = _c === void 0 ? 0 : _c, _d = _a.slides, slides = _d === void 0 ? 1 : _d, _e = _a.infiniteLoop, infiniteLoop = _e === void 0 ? false : _e, _f = _a.pauseOnMouseOver, pauseOnMouseOver = _f === void 0 ? false : _f, _g = _a.autoMove, autoMove = _g === void 0 ? true : _g, _h = _a.indicatorActiveColor, indicatorActiveColor = _h === void 0 ? 'primary' : _h, _j = _a.indicator, indicator = _j === void 0 ? true : _j, _k = _a.navigation, navigation = _k === void 0 ? true : _k, prevNavigation = _a.prevNavigation, nextNavigation = _a.nextNavigation, _l = _a.direction, direction = _l === void 0 ? 'rtl' : _l, _m = _a.rows, rows = _m === void 0 ? 1 : _m, _o = _a.navigationColor, navigationColor = _o === void 0 ? 'primary' : _o, _p = _a.tabletSlides, tabletSlides = _p === void 0 ? 1 : _p, _q = _a.mobileSlides, mobileSlides = _q === void 0 ? 1 : _q, indicatorClassName = _a.indicatorClassName;
    var _r = useState(1), showSlides = _r[0], setShowSlides = _r[1];
    var _s = React.useState(0), currentIndex = _s[0], setCurrentIndex = _s[1];
    var _t = useState(Math.round(children.length / rows)), length = _t[0], setLength = _t[1];
    var _u = useState(true), transitionEnabled = _u[0], setTransitionEnabled = _u[1];
    var _v = useState(null), touchPosition = _v[0], setTouchPosition = _v[1];
    var _w = useState(false), pause = _w[0], setPause = _w[1];
    var _x = useState([]), sliders = _x[0], setSliders = _x[1];
    var timeoutRef = React.useRef(null);
    var ref = React.useRef(null);
    var dir = React.useMemo(function () {
        if (direction === 'rtl') {
            return '+';
        }
        return '-';
    }, [direction]);
    var limit = React.useMemo(function () {
        if (rows !== 1) {
            return showSlides * rows >= children.length + 1;
        }
        return showSlides >= children.length;
    }, [showSlides, rows, children]);
    useEffect(function () {
        if (window && window.screen) {
            if (window.screen.width > 1024) {
                setShowSlides(slides);
            }
            else if (window.screen.width < 640) {
                setShowSlides(mobileSlides);
            }
            else {
                setShowSlides(tabletSlides);
            }
        }
    }, [slides, tabletSlides, mobileSlides]);
    useEffect(function () {
        var final = [];
        for (var i = 0; i < length; i++) {
            var output = [];
            for (var index = i * rows; index < rows * (i + 1); index++) {
                output.push(children[index]);
            }
            final.push(output);
        }
        setSliders(final);
    }, [children, length, rows]);
    useEffect(function () {
        setLength(Math.round(children.length / rows));
    }, [children, infiniteLoop, showSlides]);
    useEffect(function () {
        if (currentIndex === length - 1 || currentIndex === 0) {
            setTransitionEnabled(true);
        }
    }, [currentIndex, showSlides, length]);
    // @ts-ignore
    useEffect(function () {
        if (!pause && autoMove) {
            resetTimeout();
            timeoutRef.current = setTimeout(function () { return next(); }, delay);
            return function () {
                resetTimeout();
            };
        }
    }, [currentIndex, delay, pause]);
    useEffect(function () {
        if (ref.current) {
            for (var _i = 0, _a = ref.current.children; _i < _a.length; _i++) {
                var arg = _a[_i];
                arg.style.width = "calc((100% / ".concat(showSlides, ") - (").concat(spaceBetween, "px))");
                arg.style.gap = "".concat(spaceBetween, "px");
                arg.style.marginLeft = "".concat(spaceBetween / 2, "px");
                arg.style.marginRight = "".concat(spaceBetween / 2, "px");
                arg.style.flexShrink = 0;
                arg.style.flexGrow = 1;
            }
        }
    }, [showSlides, spaceBetween]);
    var resetTimeout = function () {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
    };
    var next = function () {
        if ((currentIndex < (length - showSlides) + 1) && currentIndex !== length) {
            setCurrentIndex(function (prevState) { return prevState + 1; });
        }
    };
    var prev = function () {
        if ((currentIndex > 0) && currentIndex !== showSlides) {
            setCurrentIndex(function (prevState) { return prevState - 1; });
        }
    };
    var handleTouchStart = function (e) {
        var touchDown = e.touches[0].clientX;
        setTouchPosition(touchDown);
    };
    var handleTouchMove = function (e) {
        var touchDown = touchPosition;
        if (touchDown === null) {
            return;
        }
        var currentTouch = e.touches[0].clientX;
        var diff = touchDown - currentTouch;
        if (diff > 5) {
            next();
        }
        if (diff < -5) {
            prev();
        }
        setTouchPosition(null);
    };
    var handleTransitionEnd = function () {
        if (currentIndex === length - showSlides) {
            setTimeout(function () {
                setTransitionEnabled(false);
                setCurrentIndex(0);
            }, delay / 2);
        }
    };
    var handlePauseAutoMove = function (state) {
        if (pauseOnMouseOver) {
            setPause(state);
        }
    };
    return (React.createElement(Div, { dir: direction, className: 'w-full flex-col', onMouseOver: function () { return handlePauseAutoMove(true); }, onMouseLeave: function () { return handlePauseAutoMove(false); } },
        React.createElement(Div, { className: 'w-full relative' },
            navigation && !limit ? (React.createElement(Button, { ariaLabel: 'previousNavigation', startAdornment: React.createElement(ArrowIcon, { className: 'rotate-180' }), disabled: direction === 'rtl' ? currentIndex === length - showSlides : currentIndex === 0, onClick: direction === 'rtl' ? next : prev, color: navigationColor, rounded: 'full', shape: 'square', className: 'absolute flex self-center items-center justify-center z-10 left-2' })) : null,
            prevNavigation && currentIndex > 0 ? (React.createElement(React.Fragment, null, prevNavigation(prev))) : null,
            limit ? (React.createElement("div", { ref: ref, className: 'flex shrink-0 grow w-full' }, sliders.map(function (item, itemIndex) { return (React.createElement(Div, { className: 'flex-col w-1/2', key: itemIndex }, item)); }))) : (React.createElement("div", { className: 'overflow-hidden w-full h-full', onTouchStart: handleTouchStart, onTouchMove: handleTouchMove },
                React.createElement("div", { className: "flex transition ease-linear duration-300 shrink-0 grow w-full", style: {
                        transform: "translateX(".concat(dir).concat(currentIndex * (100 / showSlides), "%)"),
                        transition: !transitionEnabled ? 'none' : undefined
                    }, onTransitionEnd: handleTransitionEnd, ref: ref }, sliders.map(function (item, itemIndex) { return (React.createElement(Div, { className: 'flex-col w-full shrink-0', key: itemIndex }, item)); })))),
            navigation && !limit ? (React.createElement(Button, { ariaLabel: 'nextNavigation', startAdornment: React.createElement(ArrowIcon, null), color: navigationColor, disabled: direction === 'rtl' ? currentIndex === 0 : currentIndex === length - showSlides, onClick: direction === 'rtl' ? prev : next, rounded: 'full', shape: 'square', className: 'absolute flex self-center items-center justify-center right-2' })) : null,
            nextNavigation && currentIndex < length ? (React.createElement(React.Fragment, null, nextNavigation(next))) : null),
        indicator && !limit ? (React.createElement(Div, { className: 'self-center items-center justify-center' }, children.length > 1 ? (React.createElement("div", { className: "flex w-[96px] justify-start gap-x-1 mt-20 pr-11 overflow-hidden ".concat(indicatorClassName) }, __spreadArray([], new Array(length - showSlides + 1), true).map(function (_, idx) {
            return (React.createElement(Div, { style: {
                    transform: "translateX(".concat(dir).concat(currentIndex * (130), "%)"),
                    transition: !transitionEnabled ? 'none' : undefined
                }, key: idx, className: classNames('w-4 h-4 min-h-4 min-w-4 rounded-full mb-0 transition-all duration-500 justify-center items-center', currentIndex === idx ? "bg-".concat(indicatorActiveColor) : 'bg-transparent'), onClick: function () {
                    setCurrentIndex(idx);
                } },
                React.createElement(Div, { className: classNames(currentIndex === idx ? "bg-".concat(indicatorActiveColor) : 'bg-grey-100', "rounded-full transition-all duration-500 justify-center items-center", BulletWidth(Math.abs(4 - Math.abs(currentIndex - idx)))) })));
        }))) : null)) : null));
};
var ArrowIcon = function (_a) {
    var className = _a.className;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "256", height: "256", viewBox: "0 0 256 256", fill: 'currentColor', className: "h-3 w-3 ".concat(className) },
        React.createElement("path", { fill: 'currentColor', strokeMiterlimit: "10", strokeWidth: "0", d: "M24.64 90L20.36 85.72 61.08 45 20.36 4.28 24.64 0 69.64 45z", transform: "matrix(2.81 0 0 2.81 1.407 1.407)" })));
};
export default Slider;
var BulletWidth = function (w) {
    switch (w) {
        case 4:
            return '!w-4 !h-4 !min-w-4 !min-h-4';
        case 3:
            return '!w-3 !h-3 !min-w-3 !min-h-3';
        case 2:
            return '!w-2 !h-2 !min-w-2 !min-h-2';
        default:
            return 'w-0 h-0';
    }
};
//# sourceMappingURL=slider.js.map